module.exports = __webpack_public_path__ + "img/material.f3edd89c.png";